<div class="flex justify-between mb-1">
	<app-anchor type="static" url=".." class="mr-2"
		><h4>{{ title }}</h4></app-anchor
	>
	<h4 class="flex-1">/ Payment calculator</h4>
</div>
<app-anchor type="static" url=".." class="mr-3">back</app-anchor>

<div class="mb-10">
	<app-container type="dark" class="rounded border border-grey-lighter">
		<div class="flex flex-wrap justify-between">
			<app-date-picker
				label="Principal as at"
				name="principalAt"
				class="flex-1 mx-1 mt-2"
				[ngModel]="encumbrance?.paymentCalc?.principalAt"
				[submitted]="true"
				(ngModelChange)="updatePrincipalAt($event)"
				[required]="true"
				[maxDate]="principalMaxDate"
				maxDateErrorLabel="the Principal To"
			></app-date-picker>
			<app-date-picker
				label="Interest to"
				name="principalTo"
				class="flex-1 mx-1 mt-2"
				[ngModel]="encumbrance?.paymentCalc?.principalFrom"
				(ngModelChange)="updatePrincipalFrom($event)"
				[submitted]="true"
				[required]="true"
				[minDate]="principalMinDate"
				minDateErrorLabel="the Principal as at"
			></app-date-picker>
		</div>
		<div class="flex mt-3">
			<app-input
				type="cents"
				label="Principal amount"
				name="principalAmount"
				[startIcon]="ICON.DOLLAR"
				[ngModel]="encumbrance?.paymentCalc?.principalAmount"
				(debounce)="updatePrincipalAmount($event)"
				class="mx-1 flex-1"
			></app-input>
		</div>
		<div class="flex flex-wrap justify-between">
			<div class="flex flex-1 mx-1 mt-2 items-end">
				<app-radio-group
					type="compact"
					label="Interest type"
					name="interestType"
					[items]="interestRateOptions"
					[ngModel]="encumbrance?.paymentCalc?.interestType"
					(ngModelChange)="updateInterestType($event)"
				></app-radio-group>
			</div>
			<app-input
				*ngIf="
					encumbrance?.paymentCalc?.interestType ===
					interestRateTypes.PER_DIEM_INTEREST
				"
				type="cents"
				label="Interest (per diem)"
				name="interestDiem"
				[startIcon]="ICON.DOLLAR"
				class="mx-1 mt-2 flex-1"
				[ngModel]="encumbrance?.paymentCalc?.interest"
				(debounce)="updateInterest($event)"
			></app-input>
			<app-input
				*ngIf="
					encumbrance?.paymentCalc?.interestType ===
					interestRateTypes.ANNUAL_RATE
				"
				type="number"
				label="Interest (annual)"
				name="interestAnnual"
				[startIcon]="ICON.PERCENTAGE"
				class="mx-1 mt-2 flex-1"
				[ngModel]="encumbrance?.paymentCalc?.interest"
				(debounce)="updateInterest($event)"
			></app-input>
		</div>
		<div class="flex flex-col mt-5 mx-2 border-t border-grey-lighter pt-2">
			<div class="flex flex-wrap items-center justify-between">
				<span class="font-bold">Additional amount</span>
				<app-button
					size="small"
					[icon]="ICON.ADD"
					class="sm:mx-0 sm:mt-2 xl:ml-5"
					(click)="addAdditionalAmount()"
					>Add additional amount</app-button
				>
			</div>
			<div class="flex flex-col">
				<div
					*ngFor="
						let additionalAmount of encumbrance?.paymentCalc?.additionalAmounts;
						let i = index;
						trackBy: trackByAdditionalAmount
					"
					class="flex mt-3 items-end"
				>
					<app-input
						label="Details"
						class="mr-2"
						[ngModel]="additionalAmount.description"
						(debounce)="updateAdditionalDesc(i, $event)"
						name="additionAmountDesc{{ i }}"
					></app-input>
					<app-input
						type="cents"
						label="Amount"
						[startIcon]="ICON.DOLLAR"
						class="ml-2"
						[ngModel]="additionalAmount.amount"
						(debounce)="updateAdditionalAmount(i, $event)"
						name="additionAmount{{ i }}"
					></app-input>
					<app-button
						btn="tertiary"
						[holdable]="true"
						[icon]="ICON.DELETE"
						(onClick)="removeAdditionalAmount(i)"
						class="ml-2"
					></app-button>
				</div>
			</div>
		</div>
		<div class="flex justify-end mt-5 text-xl">
			<span class="font-bold">Total:</span>
			<span class="ml-5 font-bold">{{
				total?.principalInterestTotal | centsToDollars
			}}</span>
		</div>
	</app-container>

	<app-container
		type="dark"
		class="rounded border border-grey-lighter mt-5"
		title="Discharge fees"
	>
		<div class="flex flex-wrap items-end">
			<div class="flex-1 mx-1 mt-2">
				<app-radio-group
					type="compact"
					label="Discharge to be registered by"
					name="dischargeBy"
					[items]="dischargeOptions"
					[ngModel]="encumbrance?.paymentCalc?.dischargeRegisteredBy"
					(ngModelChange)="updateDischargeBy($event)"
				></app-radio-group>
			</div>
			<app-input
				label="Fee"
				type="cents"
				[startIcon]="ICON.DOLLAR"
				class="flex-1 mx-1 mt-2 w-10 min-w-max"
				name="fee"
				[ngModel]="encumbrance?.paymentCalc?.fee"
				(debounce)="updateFee($event)"
			></app-input>
		</div>
		<div class="flex flex-wrap justify-between items-end mt-3">
			<div class="flex pr-2 mt-2">
				<app-checkbox
					type="clear"
					[ngModel]="encumbrance?.paymentCalc?.separateCheque"
					name="seperateCheque"
					(ngModelChange)="updateSeparateCheque($event)"
					>Make a separate cheque</app-checkbox
				>
			</div>
			<app-input
				label="Payable to"
				name="payableTo"
				class="mx-1 mt-2"
				[ngModel]="encumbrance?.paymentCalc?.payableTo"
				(debounce)="updatePayableTo($event)"
			></app-input>
		</div>
	</app-container>
</div>
